export default __webpack_public_path__ + "static/episode_1-a0ceb6e155334eacc7c83f94b955df5c.jpg";